export const SCOOTERS = [
{
  id: 1,
  name: "M12-1",
  price: "3890 AUD",
  tagline: "Most Reliable Fleet-Ready Golf Scooter",
  description: "The most tested and reliable Lectric Leisure model — built primarily for golf course fleets with rugged durability, minimal maintenance, and professional-grade features.",
  longDescription: 
  "Released in 2021, the M12-1 is Lectric Leisure’s most proven and dependable model. " +
  "Thousands have been sold worldwide, making it the preferred choice for golf course fleets. " +
  "It is extremely reliable and requires the least maintenance of all our models. " +
  "The steering column can collapse so the scooter can be lifted into the boot of an SUV. " +
  "It includes a full-cover umbrella — the most secure and effective option for sun and rain protection. " +
  "The scooter is activated via an NFC card and operates at a single fixed speed of 18 km/h. " +
  "With its stable stance, smooth ride, and turf-friendly design, the M12-1 is built for long-term fleet use and everyday golfers alike.",

  specs: [
    "Released: 2021",
    "Designed for golf course fleets",
    "NFC card start/stop",
    "Single fixed speed: 18 km/h",
    "Collapsible column for SUV transport",
    "Full-cover umbrella included",
    "Low maintenance design"
  ],

  pointers: [
    "Best choice for golf course fleets",
    "Most reliable model with lowest maintenance",
    "Thousands sold globally",
    "Column collapses for SUV loading",
    "Full-cover umbrella included",
    "NFC card access (tap to start/stop)",
    "Single fixed speed: 18 km/hr",
    "Reverse mode with audible sound"
  ],

  images: [
    "images/-1.jpg",
    "images/gallery/-1standing.jpg",
    "images/gallery/-1gallT.jpg",
    "images/gallery/-1size.jpg",
    "images/gallery/-1gall.jpg",
    "images/gallery/gallery-04.jpg"
  ],
  image: "images/-1.jpg",
},

{
  id: 2,
  name: "M12-3",
  price: "3790 AUD",
  tagline: "Rugged, Comfortable & Transport-Friendly",
  description: "A heavy-duty, high-comfort scooter designed for tough terrain, long sessions, and easy transport by splitting into two pieces.",
  longDescription:
  "Released in 2025, the M12-3 is an upgraded evolution of the M12-1. " +
  "It separates into two pieces for easier transportation in a car or SUV. " +
  "This model has been rigorously tested for over 100 hours across all terrains and gradients without failure. " +
  "It includes a hand brake that can lock as a parking brake, plus lights and a horn. " +
  "The ride-on seat is strong, comfortable, and built for long sessions on the course. " +
  "Operation is push-button start with three selectable speeds: 5 km/h, 12 km/h, and 18 km/h. " +
  "The M12-3 is the heaviest model in the Lectric Leisure range, built for maximum durability and stability.",

  specs: [
    "Released: 2025",
    "Splits into two pieces for transport",
    "Hand brake with parking lock",
    "Lights and horn included",
    "Push-button start",
    "Three speeds: 5 / 12 / 18 km",
    "Heaviest Lectric model"
  ],

  pointers: [
    "Splits into two pieces for easy transport",
    "Hand brake with parking lock",
    "Comfortable ride-on seat",
    "Built-in lights and horn",
    "Push-button start",
    "Three speed modes: 5 / 12 / 18 km",
    "Tested over 100+ hours on tough terrain",
    "Reverse mode with audible sound"
  ],

  images: [
    "images/m13-1.jpg",
    "images/gallery/-2standing.jpg",
    "images/gallery/gallery-01.jpg",
    "images/gallery/-2gallT.jpg",
    "images/gallery/gallery-01.jpg",
    "images/gallery/-2size.jpg"
  ],
  image: "images/m13-1.jpg",
},

{
  id: 3,
  name: "ESGOLF",
  price: "3450 AUD",
  tagline: "Personal Hybrid Golf Scooter + Electric Buggy",
  description: "The only Lectric model that functions both as an electric scooter and an electric golf buggy (cart mode). Compact, portable, and ideal for individual players.",
  longDescription:
  "Released in 2025, ESGOLF is designed specifically for individual golfers rather than fleet use. " +
  "It uniquely operates both as an electric golf scooter and an electric golf buggy (cart mode). " +
  "In cart mode, the unit can be guided from the front — however, if you attempt to pull it manually, the brakes will engage. " +
  "ESGOLF folds down in just three simple steps and becomes the most compact model in the range for loading into an SUV boot. " +
  "It features three selectable speed modes but does not include an LED dashboard display like the M12 models. " +
  "This makes it ideal for golfers who play multiple different courses and need easy transport between rounds.",

  specs: [
    "Released: 2025",
    "Dual-use: scooter + electric buggy",
    "Three speed modes",
    "No LED display",
    "Folds in three steps",
    "Most compact when collapsed",
    "Designed for personal golfers"
  ],

  pointers: [
    "Dual-use: electric scooter + electric golf buggy mode",
    "Three selectable speed modes",
    "No LED dashboard display",
    "Folds in three steps — most compact model",
    "Ideal for golfers who play multiple courses",
    "Designed for personal use, not fleets",
    "Reverse mode with audible sound"
  ],

  images: [
    "images/-3standing.jpg",
    "images/gallery/-3gall2.jpg",
    "images/gallery/-3gallT.jpg",
    "images/gallery/-3gall.jpg",
    "images/gallery/-3size.jpg",
    "images/gallery/-3gall3.jpg"
  ],
  image: "images/-3standing.jpg",
}
];
